// packages
import { widont } from 'journalize';
import { Component, h } from 'preact';

// components
import GranicusViewer from './components/GranicusViewer';
import StreamTab from './components/StreamTab';
import YouTubeIframe from './components/YouTubeIframe';

// internal
import getJSON from './utils/get-json';
import {
  CAMERA_STATUS_URL,
  CONVENE_TIME_URL,
  HOUSE_CAMERA_ID,
  SENATE_CAMERA_ID,
} from './constants';

class App extends Component {
  constructor() {
    super();

    this.state = {
      selectedStream: 'texastribune',
      houseInfo: '-',
      senateInfo: '-',
      texastribuneInfo: 'Sandra Bland press conference',
      houseIsLive: false,
      senateIsLive: false,
      texastribuneIsLive: true,
      texastribuneYoutubeId: 'Mdhdm30O3Z4',
    };

    this.onStreamToggle = this.onStreamToggle.bind(this);
    this.update = this.update.bind(this);
  }

  onStreamToggle(selectedStream) {
    if (this.state.selectedStream !== selectedStream) {
      this.setState({ selectedStream });
    }
  }

  componentDidMount() {
    this.update();
  }

  async update() {
    const [convenes, cameras] = await Promise.all([
      getJSON(CONVENE_TIME_URL),
      getJSON(CAMERA_STATUS_URL),
    ]);

    this.setState(
      {
        houseInfo: convenes.house,
        senateInfo: convenes.senate,
        houseIsLive: cameras.house,
        senateIsLive: cameras.senate,
        // texastribuneIsLive: true,
        // texastribuneYoutubeId: '0n3JHLi2v8c',
      },
      () => (this.timer = setTimeout(this.update, 1000 * 60 * 3))
    );
  }

  componentWillUnmount() {
    clearTimeout(this.timer);
  }

  render() {
    const {
      selectedStream,
      houseInfo,
      senateInfo,
      texastribuneInfo,
      houseIsLive,
      senateIsLive,
      texastribuneIsLive,
      texastribuneYoutubeId,
    } = this.state;

    const streamClass = `embed-responsive embed-responsive--16x9 stream-placeholder stream-placeholder--${selectedStream}`;

    return (
      <div class="app">
        <div class="video-nav">
          <StreamTab
            stream="texastribune"
            label={widont('Texas Tribune Live')}
            info={texastribuneInfo}
            isActive={selectedStream === 'texastribune'}
            isLive={texastribuneIsLive}
            onClick={this.onStreamToggle}
          />
          <StreamTab
            stream="house"
            label="Texas House"
            info={houseInfo}
            isActive={selectedStream === 'house'}
            isLive={houseIsLive}
            onClick={this.onStreamToggle}
          />
          <StreamTab
            stream="senate"
            label="Texas Senate"
            info={senateInfo}
            isActive={selectedStream === 'senate'}
            isLive={senateIsLive}
            onClick={this.onStreamToggle}
          />
        </div>
        <div class={streamClass}>
          {selectedStream === 'house' && houseIsLive && (
            <GranicusViewer
              subdomain="tlchouse"
              params={{ camera_id: HOUSE_CAMERA_ID, autostart: 1, embed: 1 }}
            />
          )}
          {selectedStream === 'senate' && senateIsLive && (
            <GranicusViewer
              subdomain="tlcsenate"
              params={{ camera_id: SENATE_CAMERA_ID, autostart: 1, embed: 1 }}
            />
          )}
          {selectedStream === 'texastribune' && texastribuneIsLive && (
            <YouTubeIframe id={texastribuneYoutubeId} />
          )}
        </div>
      </div>
    );
  }
}

export default App;
